import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Hoja lateral con el listado de preguntas de una encuesta: cuál va, cuáles ya están respondidas y
 * a cuál se puede saltar directamente. Genérica — recibe el texto y el estado de cada pregunta de
 * quien la use, no conoce la ruta ni el formato de la encuesta.
 */
@Component({
  selector: 'app-survey-question-panel',
  templateUrl: './survey-question-panel.component.html',
  styleUrls: ['./survey-question-panel.component.scss'],
})
export class SurveyQuestionPanelComponent {
  @Input() open = false;
  @Input() questions: any[] = [];
  @Input() index = 0;
  @Input() labelOf: (question: any) => string = (question) => String(question?.label ?? '');
  @Input() answeredOf: (question: any) => boolean = () => false;
  @Input() title = 'Preguntas';
  @Input() sectionLabel = 'Contenido';

  /** Índice de la pregunta elegida; quien usa el panel decide si cierra o no. */
  @Output() select = new EventEmitter<number>();
  @Output() closed = new EventEmitter<void>();

  pick(index: number): void {
    this.select.emit(index);
  }

  trackByIndex(index: number): number {
    return index;
  }
}
